export const REQUIRED = 'Required field';
export const EMAIL = 'Email is not valid';
export const DATE = "Date must be later than 'Start Date'";
export const MATCHPWD = `New password and Repeat Password don't match`;
export const PWDSAVED = 'Password updated successfully';